<template>
  <div class="consent-otp-wrapper">
    <b-card :header="consentType + ' Consent Verification'" class="mb-3">
      <div v-if="consentVerified" class="text-center">
        <b-badge variant="success" class="p-2">
          Consent Verified at {{ verifiedAt }}
        </b-badge>
      </div>
      <div v-else>
        <b-row>
          <b-col cols="12" md="6">
            <p class="mb-2">
              Phone: ****{{ phoneLast4 || "XXXX" }}
            </p>
            <b-button
              variant="primary"
              size="sm"
              :disabled="disabled || otpSent"
              @click="sendOtp"
            >
              {{ otpSent ? "OTP Sent" : "Request OTP" }}
            </b-button>
          </b-col>
          <b-col cols="12" md="6" v-if="otpSent">
            <b-form-group label="Enter OTP" label-size="sm">
              <b-input-group>
                <b-form-input
                  v-model="otpCode"
                  placeholder="6-digit OTP"
                  maxlength="6"
                  :disabled="disabled"
                  size="sm"
                />
                <b-input-group-append>
                  <b-button
                    variant="success"
                    size="sm"
                    :disabled="disabled || otpCode.length < 6"
                    @click="verifyOtp"
                  >
                    Verify
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <p v-if="errorMsg" class="text-danger mt-2 mb-0">{{ errorMsg }}</p>
      </div>
    </b-card>
  </div>
</template>

<script>
import recipientService from "../../assets/services/recipient.service";

export default {
  props: {
    consentType: { type: String, default: "PATIENT" },
    referenceType: { type: String, default: "RECIPIENT" },
    referenceId: { type: [Number, String], default: 0 },
    phoneNumber: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      otpSent: false,
      otpCode: "",
      phoneLast4: "",
      consentVerified: false,
      verifiedAt: "",
      errorMsg: "",
    };
  },
  methods: {
    async sendOtp() {
      this.errorMsg = "";
      try {
        this.$loader.show();
        const { data } = await recipientService.consentSendOtp({
          consent_type: this.consentType,
          reference_type: this.referenceType,
          reference_id: this.referenceId,
          phone_number: this.phoneNumber,
        });
        if (data.status) {
          this.otpSent = true;
          this.phoneLast4 = data.phone_last4 || "";
          this.$alert.show("OTP sent successfully", "success");
        } else {
          this.errorMsg = data.msg || "Failed to send OTP";
        }
        this.$loader.hide();
      } catch (error) {
        this.$loader.hide();
        this.errorMsg = "Error sending OTP";
      }
    },
    async verifyOtp() {
      this.errorMsg = "";
      try {
        this.$loader.show();
        const { data } = await recipientService.consentVerifyOtp({
          consent_type: this.consentType,
          reference_type: this.referenceType,
          reference_id: this.referenceId,
          phone_number: this.phoneNumber,
          otp_code: this.otpCode,
        });
        if (data.status) {
          this.consentVerified = true;
          this.verifiedAt = new Date().toLocaleString();
          this.$emit("consent-verified", {
            consent_otp_id: data.list ? data.list[0]?.consent_otp_id : null,
            timestamp: this.verifiedAt,
          });
          this.$alert.show("Consent verified successfully", "success");
        } else {
          this.errorMsg = data.msg || "Invalid or expired OTP";
        }
        this.$loader.hide();
      } catch (error) {
        this.$loader.hide();
        this.errorMsg = "Error verifying OTP";
      }
    },
  },
};
</script>
